import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

require.ensure([], () => {  
    require('./WeekSheetApproval.less');
});

class TaskView extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleClick = () => {
        this.props.handleClick();
    }

    // OHTER METHODS
    
    // RENDER METHOD

    render = () => {

        if (this.props.active) {
            return (
                <div className="panel panel-default panel-pmtask">
                    <div className="panel-heading" role="tab" id="headingOne-inner">
                        <h4 className="panel-title">
                        <a style={{"cursor" : "pointer"}} onClick={this.handleClick} data-toggle="collapse" data-parent="#accordion-inner" aria-expanded="true" aria-controls="collapseOne">
                            <span className="acc" style={{borderColor : "#888"}}>
                                <span className="md-expand-more" style={{"color" : "#888"}}></span>
                            </span>
                            Weekly work by tasks
                        </a>
                        </h4>
                    </div>
                    <div id="collapseOne-inner" className="panel-collapse" role="tabpanel" aria-labelledby="headingOne-inner">
                        <div className="panel-body">
                              <table className="table table-condensed">
                                    <tbody>
                                        {
                                            this.props.taskKeys.map((taskID, key) => {
                                                let logEntry = this.props.tasks[taskID]; //task = logEntry
                                                let projectHours = this.props.projectHours[logEntry.projectID];

                                                let regularHours = logEntry.regularHours;
                                                let regularMinutes = logEntry.regularMinutes;
                                                let overtimeHours = logEntry.overtimeHours;
                                                let overtimeMinutes = logEntry.overtimeMinutes;

                                                let projectRegularHours = projectHours.regularHours;
                                                let projectRegularMinutes = projectHours.regularMinutes;
                                                let projectOvertimeHours = projectHours.overtimeHours;
                                                let projectOvertimeMinutes = projectHours.overtimeMinutes;
                                                
                                                let approvedHours = logEntry.approvedHours;
                                                let status = this.props.status;
                                                if (approvedHours && status === "SUBMITTED" && approvedHours.timeTotal === approvedHours.timeApproved) {
                                                    status = "APPROVED";
                                                }

                                                return (
                                                    <tr key={key}>
                                                        <td style={{"maxWidth" : "500px", "borderLeft" : "5px solid " + logEntry.color}}>
                                                            <span style={{"fontSize" : "12px"}}>
                                                                {logEntry.projectName}&nbsp;&nbsp;({projectRegularHours + "h " + projectRegularMinutes + "min"}
                                                                <span style={{"color" : "red"}}>
                                                                    {projectOvertimeHours > 0 || projectOvertimeMinutes > 0 ? " + " + projectOvertimeHours + "h " + projectOvertimeMinutes + "min" : ""}
                                                                </span>)
                                                            </span>
                                                        <br/>
                                                        <span style={{"fontSize" : "12px"}}>{logEntry.taskName}</span>
                                                        </td>
                                                        <td style={{"width" : "25%"}}></td>
                                                        <td>
                                                            <span style={ status === "ENTRY" ? {"color" : "#888", fontStyle : "italic"} : {"color" : "#888"}}>
                                                                {regularHours + "h"}{regularMinutes > 0 ? " " + regularMinutes + "min" : ""}
                                                                { status === "APPROVED" ? <span className="pull-right md-done"/> : null }
                                                                { status === "ENTRY" && approvedHours && approvedHours.timePrevRejected > 0 ? <span className="pull-right md-report"/> : null}
                                                                <br/>
                                                                <span className="mock" style={overtimeHours > 0 || overtimeMinutes > 0 ? {"color" : "red"} : {}}>
                                                                    {overtimeHours > 0 || overtimeMinutes > 0 ? overtimeHours + "h" : ""}{overtimeMinutes > 0 ? " " + overtimeMinutes + "min" : ""}
                                                                </span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                              </table>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="panel panel-default panel-pmtask">
                    <div className="panel-heading" role="tab" id="headingOne-inner">
                        <h4 className="panel-title">
                        <a style={{"cursor" : "pointer"}} onClick={this.handleClick} data-toggle="collapse" data-parent="#accordion-inner" aria-expanded="true" aria-controls="collapseOne">
                            <span className="acc" style={{borderColor : "#888"}}><span className="md-chevron-right" style={{"color" : "#888"}}></span></span>
                            Weekly work by tasks
                        </a>
                        </h4>
                    </div>
                </div>
            );
        }
    }
}

TaskView.propTypes = {
    active: PropTypes.bool,
    approvedHours: PropTypes.array,
    handleClick: PropTypes.func,
    projectHours: PropTypes.object,
    status: PropTypes.string,
    taskKeys: PropTypes.array,
    tasks: PropTypes.object
};

TaskView.defaultProps = {
    projectHours: {},
    taskKeys: [],
    tasks: {}
};

const mapStateToProps = (state) => {
    let logEntriesByTimesheetTasks = state.logEntries.logEntriesByTimesheetTasks;
    return {
        projectHours: logEntriesByTimesheetTasks.projectHours,
        taskKeys: logEntriesByTimesheetTasks.taskKeys,
        tasks: logEntriesByTimesheetTasks.tasks
    };
};

export default connect(
    mapStateToProps
)(TaskView);



/** WEBPACK FOOTER **
 ** ./src/app/components/TaskView.js
 **/